import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getWaterRightTypeList as getWaterRightTypeListApi,
	getWaterRightTypeListQuery as getWaterRightTypeListQueryApi,
	getWaterRightType as getWaterRightTypeApi,
	addNewWaterRightTypeApi,
	updateWaterRightTypeApi,
	deleteWaterRightTypeApi,
	checkWaterRightTypeExistsApi,
} from '../../helpers/water_right_type/api_helper';

export const getWaterRightTypeList = createAsyncThunk(
	'waterRightType/getWaterRightTypeList',
	async () => {
		try {
			const response = await getWaterRightTypeListApi();
			// Extract data array from response
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener los tipos de derecho.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getWaterRightTypeListQuery = createAsyncThunk(
	'waterRightType/getWaterRightTypeListQuery',
	async params => {
		try {
			const response = getWaterRightTypeListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getWaterRightType = createAsyncThunk(
	'waterRightType/getWaterRightType',
	async water_right_type_id => {
		try {
			const response = await getWaterRightTypeApi(water_right_type_id);
			return response;
		} catch (error) {
			toast.error('Error al obtener el tipo de derecho.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewWaterRightType = createAsyncThunk(
	'waterRightType/addNewWaterRightType',
	async water_right_type => {
		try {
			const response = await addNewWaterRightTypeApi(water_right_type);
			toast.success('Tipo de Derecho agregado exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar el tipo de derecho.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateWaterRightType = createAsyncThunk(
	'waterRightType/updateWaterRightType',
	async water_right_type => {
		try {
			const response = await updateWaterRightTypeApi(water_right_type);
			toast.success('Tipo de Derecho actualizado exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar el tipo de derecho.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteWaterRightType = createAsyncThunk(
	'waterRightType/deleteWaterRightType',
	async water_right_type => {
		try {
			const response = await deleteWaterRightTypeApi(water_right_type._id);
			toast.success('Tipo de Derecho eliminado exitosamente.', {
				autoClose: 3000,
			});
			// Return the original object to identify which item to remove
			return water_right_type;
		} catch (error) {
			toast.error('Error al eliminar el tipo de derecho.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkWaterRightTypeExists = createAsyncThunk(
	'waterRightType/checkWaterRightTypeExists',
	async name => {
		try {
			const response = await checkWaterRightTypeExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
